import React from "react";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";
import PlanOfferingsBlock from "~/components/makers/PlanOfferingsBlock";
import PlanOfferings from "~/components/makers/PlanOfferings";
import { CheckEmoji } from "~/components/makers/Emojis";
import Strongify from "~/lib/utils/strongify";

export default function ToBasicPlanOption() {
  return (
    <div
      css={{
        padding: 20,
        border: `solid 1px ${palette.lightestGray}`,
        borderRadius: 4,
      }}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 12,
        }}
      >
        <strong
          css={{
            fontSize: 16,
            fontWeight: "bold",
            color: palette.innovatorBlue,
            fontStyle: "italic",
            textTransform: "uppercase",
          }}
        >
          <FormattedMessage defaultMessage="New Plan" id="U2j/jE" />
        </strong>

        <h2
          css={{
            margin: 0,
            fontSize: 24,
            color: "#4a4a4a",
          }}
        >
          Basic
        </h2>

        <h3
          css={{
            margin: 0,
            color: "#797979",
            fontWeight: "bold",
            fontSize: 24,
          }}
        >
          $0
          <span
            css={{
              fontSize: 24,
              fontWeight: "normal",
              color: "#9f9f9f",
            }}
          >
            /<FormattedMessage defaultMessage="month" id="Cu3Cty" />
          </span>
        </h3>

        <div
          css={{
            padding: "10px 0px",
          }}
        >
          <PlanOfferingsBlock>
            <PlanOfferings>
              <li>
                {CheckEmoji} <FormattedMessage defaultMessage="Basic product profiles" id="AcV6wk" />
              </li>
              <li>
                {CheckEmoji}{" "}
                <FormattedMessage
                  defaultMessage="Up to <strong>{chunk}</strong> per product" id="oiRzjp"
                  values={{
                    chunk: `1 category tag`,
                    strong: (chunk: any) => Strongify(chunk),
                  }}
                />
              </li>
              <li>
                {CheckEmoji} <FormattedMessage defaultMessage="Basic vendor profile" id="Aw7JHD" />
              </li>
              <li>
                {CheckEmoji}{" "}
                <FormattedMessage
                  defaultMessage="Up to <strong>{teamMembers}</strong> team member" id="So4cAG"
                  values={{
                    teamMembers: 1,
                    strong: (chunk: any) => Strongify(chunk),
                  }}
                />
              </li>
            </PlanOfferings>
          </PlanOfferingsBlock>
        </div>
      </div>
    </div>
  );
}
